
/*global moment*/

import { formatColumnValueAsync, formatValue } from "../../util/formatter.js";
import { getFieldAndBindPath } from "../../util/schema-helper.js";


const COMPONENT_NAME = "z-format" ;

export default function register(){
    class FormatComponent extends HTMLElement {
        constructor() {
            super();
            
        }

        connectedCallback(){
            if(this.hasAttribute("value")){
                this.value = this.getAttribute("value") ;
            }
        }

        get value(){
            return this.getAttribute("value");
        }
        set value(value){
            this.setAttribute("value", value) ;
            if(this.hasAttribute("z-model")){
                let {field} = getFieldAndBindPath(this.getAttribute("z-model"), this.getAttribute("z-app")) ;
                formatColumnValueAsync(field, value, this.getAttribute("z-app")).then((value)=>{
                    this.innerHTML = value ;
                }).catch(err=>{
                    console.error("Error while render z-format", err) ;
                });
            }else if(this.hasAttribute("z-date-format")){
                if(!value){
                    value = "" ;
                }else{
                    let dt;
                    if(value && /^\d{2}:\d{2}:\d{2}$/.test(value)){
                        //time data
                        dt = moment(value, "HH:mm:ss") ;
                    }else{
                        dt = moment(value) ;
                    }
                    if(!dt.isValid()){
                        value="" ;
                    }else{
                        value = dt.format(this.getAttribute("z-date-format")) ;
                    }
                }
                this.innerHTML = value ;
            }else{
                this.innerHTML = formatValue(value, this.getAttribute("type")) ;
            }
        }
    }
    customElements.define(COMPONENT_NAME, FormatComponent);
}
